import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { StepperModule } from 'primeng/stepper';
import { VaccineResponse } from '../../models/vaccine-response';
import { LanguageVariables } from '../../models/voucher-program-request';
import { VaccineService } from '../../services/vaccine.service';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CompanyService } from '../../services/company.service';
import { VoucherProgramService } from '../../services/voucher-program.service';
import { finalize, forkJoin } from 'rxjs';
import { Messages, ValidationPatterns } from '../../../common/constants/messages';
import { NgxMaskDirective } from 'ngx-mask';
import { VoucherProgramRequest, VaccineDto } from '../../models/voucher-program-request';
import { GooglePlacesService } from '../../../services/google-places.service';
import { UniversalTandCData2025 } from '../../../common/constants/universalTandCData';
import { TableModule } from 'primeng/table';
import { VerificationStatusEnum } from '../../../common/enums/verification-status.enum';
import { CanComponentDeactivate } from '../../../app/guards/can-deactivate.interface';
import { UnsavedTrackingService } from '../../../services/unsaved-changes.service';
import { InvalidCharsPipe } from '../../../common/Helpers/invalid-chars.pipe';
import { RouterModule } from '@angular/router';
import { GooglePlaceAutocompleteComponent } from '../../../common/components/google-place-autocomplete/google-place-autocomplete.component';

@Component({
  selector: 'app-voucher-setup',
  standalone: true,
  imports: [CommonModule, StepperModule, ReactiveFormsModule, ButtonModule, NgxSpinnerModule, DialogModule, DatePickerModule,
    FileUploadModule, NgxMaskDirective, TableModule, InvalidCharsPipe, RouterModule,GooglePlaceAutocompleteComponent],
  templateUrl: './voucher-setup.component.html',
  styleUrl: './voucher-setup.component.css'
})
export class VoucherSetupComponent implements OnInit, CanComponentDeactivate {

  today = new Date();
  activeStep: number = 1;
  voucherForm!: FormGroup;
  vaccineList: VaccineResponse[] = [];
  filteredVaccineList: VaccineResponse[] = [];
  groupedList: any[] = [];
  activeIndex: number[] = [];
  categoryList: any[] = [];
  cdcLink = '';
  cdcLinks: any[] = [];
  dialogTitle = '';
  dialogBodyText1 = '';
  dialogBodyText2? = '';
  visible = false;
  isLoading = false;
  openIndexes: number[] = [];
  stateList: any[] = [];
  modalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  companyId: string = '';
  companyName: string = '';
  company: any = null;
  roleCode: string = '';
  date = new Date();
  default_routine_exp_date = new Date(this.date.getFullYear() + 1, this.date.getMonth(), this.date.getDate(), 12, 0, 0);
  default_flu_exp_date = new Date(this.date.getFullYear() + 1, 3, 30, 12, 0, 0);
  fluExpiryMinDate = new Date();
  routineExpiryMinDate = new Date();
  fluExpiryMaxDate = new Date();
  routineExpiryMaxDate = new Date();
  minDate = new Date();
  showCancelConfirm = false;
  dialogType: 'normal' | 'unsaved' | 'business-verification' = 'normal';
  data = UniversalTandCData2025;
  languageVariables = new LanguageVariables();
  isCovidVaccineAvailable = false;
  englishLanguage = '';
  enheader = '';
  isFluVaccine = false;
  isRoutineVaccine = false;
  w9Approved = false;
  step5Title = 'Business Verification';
  vouchersList = [];
  agreementFile: any;
  maxCompletedStep: number = 1;
  isSubmitted: boolean = false;
  @ViewChild('fileUploadRef') fileUploadRef!: FileUpload;
  isW9Uploaded: boolean = false;
  voucherFiles: any[] = [];
  maxRoutineVaccineSelections = 11;
  private skipUnsavedChangesGuard = false;
  private resolveGuard!: (value: boolean) => void;
  readonly ValidationPatterns = ValidationPatterns;
  triggerFileSelect() {
    this.fileUploadRef.choose();
  }
  constructor(
    private ngx: NgxSpinnerService,
    private router: Router,
    private vaccineService: VaccineService,
    private fb: FormBuilder,
    private companyService: CompanyService,
    private voucherService: VoucherProgramService,
    private unsavedService: UnsavedTrackingService,
    private scroller: ViewportScroller
  ) {
    this.languageVariables.pageTitle = UniversalTandCData2025.pageTitleEN;
    this.englishLanguage = UniversalTandCData2025.english;
    this.enheader = UniversalTandCData2025.englishheader;
  }

  ngOnInit(): void {
    sessionStorage.removeItem('isLoggingOut');
    this.companyId = sessionStorage.getItem('companyId') || '';
    this.companyName = sessionStorage.getItem('companyName') || '';
    this.roleCode = sessionStorage.getItem('roleCode')?.toString() || '';
    if (this.roleCode === '1') {
      this.fluExpiryMaxDate = new Date(9999, 11, 31);
      this.routineExpiryMaxDate = new Date(9999, 11, 31);
    }
    else {
      this.fluExpiryMaxDate = this.default_flu_exp_date;
      this.routineExpiryMaxDate = this.default_routine_exp_date;
    }
    this.activeStep = 1;
    this.buildForm();
    this.loadDefaultData();

    this.step3Group.get('zip')?.valueChanges.subscribe(value => {
      if (value) {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned !== value) {
          this.step3Group.get('zip')?.setValue(cleaned, { emitEvent: false });
        }
      }
    });

    this.step3Group.get('legalZip')?.valueChanges.subscribe(value => {
      if (value) {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned !== value) {
          this.step3Group.get('legalZip')?.setValue(cleaned, { emitEvent: false });
        }
      }
    });
  }

  /* ================= UNSAVED CHANGES WARNING ================= */
  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {

    if (sessionStorage.getItem('isLoggingOut') === 'true') {
      return;
    }

    if (this.isSubmitted) {
      return;
    }

    const hasChanges =
      this.voucherForm?.dirty ||
      this.step1Group?.value?.vaccines?.length > 0;

    if (hasChanges) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  buildForm() {
    const namePattern = new RegExp(
      ValidationPatterns.NAME,
      "u"
    );
    this.voucherForm = this.fb.group({
      step1: this.fb.group({
        vaccines: [[], Validators.required]
      }),
      step2: this.fb.group({
        programName: ['', [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern(ValidationPatterns.BUSINESS)
        ]],
        fluVoucherExpireDate: ['', Validators.required],
        routineVoucherExpireDate: ['', Validators.required]
      }),
      step3: this.fb.group({
        sameAsBusiness: [false],
        businessName: ['', [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern(ValidationPatterns.BUSINESS)
        ]],
        taxExempt: ['', Validators.required],
        employerIdentificationNumber: ['', [Validators.required, Validators.pattern(ValidationPatterns.EIN)]],
        firstName: ['', [Validators.required, Validators.pattern(namePattern)]],
        lastName: ['', [Validators.required, Validators.pattern(namePattern)]],
        phone: ['', [Validators.required, Validators.pattern(ValidationPatterns.PHONE)]],
        fax: ['', [Validators.pattern(ValidationPatterns.PHONE), Validators.maxLength(10)]],
        email: ['', [Validators.required, Validators.email]],
        verifyEmail: ['', [Validators.required, Validators.email]],
        address1: ['', [
          Validators.required,
          Validators.pattern(ValidationPatterns.ADDRESS)
        ]],
        address2: ['', [
          Validators.pattern(ValidationPatterns.ADDRESS)
        ]],
        city: ['', [Validators.required, Validators.pattern(ValidationPatterns.CITY)]],
        state: ['', Validators.required],
        zip: ['', [
          Validators.required,
          Validators.pattern(ValidationPatterns.ZIP)
        ]],
        legalSameAsBusiness: [false],
        legalFirstName: ['', [Validators.required, Validators.pattern(namePattern)]],
        legalLastName: ['', [Validators.required, Validators.pattern(namePattern)]],
        legalAddress1: ['', [
          Validators.required,
          Validators.pattern(ValidationPatterns.ADDRESS)
        ]],
        legalAddress2: ['', [
          Validators.pattern(ValidationPatterns.ADDRESS)
        ]],
        legalCity: ['', [Validators.required, Validators.pattern(ValidationPatterns.CITY)]],
        legalState: ['', Validators.required],
        legalZip: ['', [
          Validators.required,
          Validators.pattern(ValidationPatterns.ZIP)
        ]]
      }),
      step4: this.fb.group({
        consent: [false, Validators.requiredTrue],
        signatureName: ['', Validators.required],
        signatureJobTitle: ['', [Validators.required, Validators.pattern(new RegExp(
          ValidationPatterns.JOB, "u"))]],
        signatureDate: [{ value: new Date(), disabled: true }]
      })
      // ,
      // step5: this.fb.group({
      //   w9File: [null]
      // })
    });
  }

  get step1Group(): FormGroup {
    return this.voucherForm.get('step1') as FormGroup;
  }

  get step2Group(): FormGroup {
    return this.voucherForm.get('step2') as FormGroup;
  }

  get step3Group(): FormGroup {
    return this.voucherForm.get('step3') as FormGroup;
  }

  get step4Group(): FormGroup {
    return this.voucherForm.get('step4') as FormGroup;
  }

  get step5Group(): FormGroup {
    return this.voucherForm.get('step5') as FormGroup;
  }

  nextStep(stepName: string, currentValue: number) {
    const group = this.voucherForm.get(stepName) as FormGroup;

    if (!this.w9Approved && !this.isW9Uploaded) {
      this.dialogSummary = 'Complete Business Verification';
      this.dialogMsg = 'To continue with voucher setup, you’ll need to upload your business or organization’s IRS Form W-9 and provide your EIN for business verification.';
      this.dialogType = 'business-verification';
      this.modalDlg = true;
      return;
    }
    else if (!this.w9Approved && this.isW9Uploaded) {
      this.dialogSummary = 'Business Verification Pending';
      this.dialogMsg = 'You\'re business verification is under way! As soon as your account is approved, we\'ll send you a follow-up email and you can start your Employee Voucher Program.';
      this.dialogType = 'normal';
      this.modalDlg = true;
      return;
    }

    if (group?.invalid) {
      group.markAllAsTouched();
      if (this.activeStep === 1) {
        this.dialogSummary = 'Selection Required';
        this.dialogMsg = 'Please select at least one vaccine in order to continue.';
      }
      else {
        this.dialogSummary = Messages.ValidationTitle;
        this.dialogMsg = Messages.ValidationMessage;
      }
      this.dialogType = 'normal';
      this.modalDlg = true;
      return;
    }

    if (currentValue === 4) {
      this.submitVoucher();
      return;
    }

    this.activeStep = currentValue + 1;

    if (this.activeStep === 2) {
      let vaccineList = group.get('vaccines')?.value;
      this.isFluVaccine = false;
      this.isRoutineVaccine = false;
      vaccineList.forEach((vaccine: VaccineResponse) => {
        if (vaccine.vaccineTypeName === 'Flu (Influenza)' || vaccine.vaccineTypeName === 'Trivalent 65+') {
          this.isFluVaccine = true;
        }
        else {
          this.isRoutineVaccine = true;
        }
      });
    }
    this.maxCompletedStep = Math.max(this.maxCompletedStep, this.activeStep);
    this.handleStepChange();
  }

  isInvalid(groupName: string, controlName: string) {
    const control = this.voucherForm.get(`${groupName}.${controlName}`);
    return control?.invalid && control?.touched;
  }

  toggleAddressSync() {
    const same = this.step3Group.get('sameAsBusiness')?.value;

    if (same && this.company) {
      this.step3Group.get('businessName')?.setValue(this.company.companyName);
      this.step3Group.get('taxExempt')?.setValue(this.company.taxExempt);
      this.step3Group.get('employerIdentificationNumber')?.setValue(this.company.employerIdentificationNumber);
      this.step3Group.get('firstName')?.setValue(this.company.primaryContactFirstName);
      this.step3Group.get('lastName')?.setValue(this.company.primaryContactLastName);
      this.step3Group.get('phone')?.setValue(this.company.companyPhone);
      this.step3Group.get('fax')?.setValue(this.company.companyFax);
      this.step3Group.get('email')?.setValue(this.company.companyEmail);
      this.step3Group.get('verifyEmail')?.setValue(this.company.companyEmail);
      this.step3Group.get('address1')?.setValue(this.company.address1);
      this.step3Group.get('address2')?.setValue(this.company.address2);
      this.step3Group.get('city')?.setValue(this.company.city);
      this.step3Group.get('state')?.setValue(this.company.state);
      this.step3Group.get('zip')?.setValue(this.company.zip);

    } else {

    }
  }

  toggleLegalAddressSync() {
    const same = this.step3Group.get('legalSameAsBusiness')?.value;

    if (same && this.company) {
      this.step3Group.get('legalFirstName')?.setValue(this.company.primaryContactFirstName);
      this.step3Group.get('legalLastName')?.setValue(this.company.primaryContactLastName);
      this.step3Group.get('legalAddress1')?.setValue(this.company.address1);
      this.step3Group.get('legalAddress2')?.setValue(this.company.address2);
      this.step3Group.get('legalCity')?.setValue(this.company.city);
      this.step3Group.get('legalState')?.setValue(this.company.state);
      this.step3Group.get('legalZip')?.setValue(this.company.zip);
    } else {

    }
  }

  cancel(): void {
    this.router.navigate(['/home']);
  }

  stayOnPage() {
    this.modalDlg = false;
    this.router.navigate(['/home']);
    if (this.resolveGuard) {
      this.resolveGuard(false);
    }
  }

  leavePage() {
    this.modalDlg = false;
    this.router.navigate(['/home']);
    if (this.resolveGuard) {
      this.resolveGuard(true);
    }
  }
  confirmCancel() {
    this.showCancelConfirm = false;
    this.router.navigate(['/home']);
  }

  toggle(index: number) {
    if (this.openIndexes.includes(index)) {
      this.openIndexes = this.openIndexes.filter(i => i !== index);
    } else {
      this.openIndexes.push(index);
    }
  }

  displayFieldCss(path: string) {
    return { 'has-error': this.isFieldInvalid(path) };
  }

  isFieldInvalid(path: string): boolean {
    const control = this.voucherForm.get(path);
    return !!(control && control.invalid && control.touched);
    return false;
  }

  groupList(data: VaccineResponse[]) {
    const map = new Map<string, any>();
    data.forEach(item => {
      if (!map.has(item.vaccineTypeName)) {
        map.set(item.vaccineTypeName, { name: item.vaccineTypeName, items: [] });
      }
      map.get(item.vaccineTypeName).items.push(item);
    });
    this.groupedList = Array.from(map.values());
  }

  onCategoryChange(categoryCode: string) {
    if (categoryCode === '') {
      this.filteredVaccineList = this.vaccineList;
    }
    else {
      this.filteredVaccineList = this.vaccineList.filter(c => c.categoryCode.toString() == categoryCode);
    }
    // this.groupList(this.filteredVaccineList);
  }

  openDialog(item: VaccineResponse) {
    this.visible = true;
    this.dialogTitle = item.vaccineName + ' ' + item.vaccineNameShort;
    this.cdcLink = item.cdcLink;
    this.cdcLinks = item.vaccineLinks;
    this.dialogBodyText1 = item.whyVaccineNeeded;
    this.dialogBodyText2 = item.whyPeopleNeed;
  }

  closeDialog() {
    this.visible = false;
    this.dialogTitle = '';
    this.cdcLink = '';
    this.cdcLinks = [];
    this.dialogBodyText1 = '';
    this.dialogBodyText2 = '';
  }


  previousStep(step: number) {
    if (this.isSubmitted) return;

    this.activeStep = step - 1;
    this.handleStepChange();
  }

  private handleStepChange() {
  }
  submitVoucher() {

    // Validate Steps 1–4
    if (
      this.step1Group.invalid ||
      this.step2Group.invalid ||
      this.step3Group.invalid ||
      this.step4Group.invalid
    ) {
      this.voucherForm.markAllAsTouched();
      return;
    }

    if (this.voucherForm.invalid) {
      this.voucherForm.markAllAsTouched();
      return;
    }
    let voucherVaccines: VaccineDto[] = [];
    let vaccines: any[] = this.step1Group.value.vaccines;
    voucherVaccines = vaccines.map(vaccine => ({
      vaccineId: vaccine.vaccineId,
      vaccineName: vaccine.vaccineName + ' ' + vaccine.vaccineNameShort,
      vaccineNameSp: vaccine.vaccineNameSpanish + ' ' + vaccine.vaccineNameSpanishShort,
      abbrevatedVaccineName: vaccine.abbrevatedVaccineName,
      abbrevatedVaccineNameSpanish: vaccine.abbrevatedVaccineNameSpanish,
      vaccinePrice: vaccine.vaccinePrice
    }));

    const payload: VoucherProgramRequest = {
      companyId: this.companyId,
      companyName: this.companyName,
      voucherVaccinesJson: voucherVaccines,
      voucherProgramName: this.step2Group.value.programName,
      fluVoucherExpirationDate: this.step2Group.value.fluVoucherExpireDate,
      routineVoucherExpirationDate: this.step2Group.value.routineVoucherExpireDate,
      businessName: this.step3Group.value.businessName.trim(),
      taxExempt: this.toBoolean(this.step3Group.value.taxExempt),
      employerIdentificationNumber: this.step3Group.value.employerIdentificationNumber,
      phone: this.step3Group.value.phone,
      email: this.step3Group.value.email,
      fax: this.step3Group.value.fax,
      billingFirstName: this.step3Group.value.firstName.trim(),
      billingLastName: this.step3Group.value.lastName.trim(),
      billingAddress1: this.step3Group.value.address1.trim(),
      billingAddress2: this.step3Group.value.address2.trim(),
      billingCity: this.step3Group.value.city.trim(),
      billingState: this.step3Group.value.state.trim(),
      billingZip: this.step3Group.value.zip,
      legalFirstName: this.step3Group.value.legalFirstName.trim(),
      legalLastName: this.step3Group.value.legalLastName.trim(),
      legalAddress1: this.step3Group.value.legalAddress1.trim(),
      legalAddress2: this.step3Group.value.legalAddress2.trim(),
      legalCity: this.step3Group.value.legalCity.trim(),
      legalState: this.step3Group.value.legalState.trim(),
      legalZip: this.step3Group.value.legalZip,
      agreementVersion: '1.0',
      agreementText: '',
      consentElectronic: this.step4Group.value.consent,
      signatureName: this.step4Group.value.signatureName,
      signatureJobTitle: this.step4Group.value.signatureJobTitle.trim(),
      signatureDate: new Date(),
      w9DocumentFile: null,
      sameAsBusiness: this.step3Group.value.sameAsBusiness,
    };

    this.submit(payload);
    setTimeout(() => {
      this.scroller.scrollToPosition([0, 0]);
    }, 100);
  }

  submit(request: VoucherProgramRequest) {

    const formData = new FormData();
    request.fluVoucherExpirationDate.setHours(12, 0, 0);
    request.routineVoucherExpirationDate.setHours(12, 0, 0);

    formData.append('CompanyId', request.companyId.toString());
    formData.append('CompanyName', request.companyName);
    formData.append('VoucherVaccinesJson', JSON.stringify(request.voucherVaccinesJson));
    formData.append('VoucherProgramName', request.voucherProgramName);
    formData.append('BusinessName', request.businessName);
    formData.append('FluVoucherExpirationDate',
      request.fluVoucherExpirationDate.toISOString().split('T')[0]);

    formData.append('RoutineVoucherExpirationDate',
      request.routineVoucherExpirationDate.toISOString().split('T')[0]);

    formData.append('Phone', request.phone);
    formData.append('Fax', request.fax);
    formData.append('Email', request.email);
    formData.append('TaxExempt', request.taxExempt.toString());
    formData.append('EmployerIdentificationNumber', request.employerIdentificationNumber);

    formData.append('BillingFirstName', request.billingFirstName);
    formData.append('BillingLastName', request.billingLastName);
    formData.append('BillingAddress1', request.billingAddress1);
    formData.append('BillingAddress2', request.billingAddress2);
    formData.append('BillingCity', request.billingCity);
    formData.append('BillingState', request.billingState);
    formData.append('BillingZip', request.billingZip);

    formData.append('LegalFirstName', request.legalFirstName);
    formData.append('LegalLastName', request.legalLastName);
    formData.append('LegalAddress1', request.legalAddress1);
    formData.append('LegalAddress2', request.legalAddress2);
    formData.append('LegalCity', request.legalCity);
    formData.append('LegalState', request.legalState);
    formData.append('LegalZip', request.legalZip);

    formData.append('ConsentElectronic', request.consentElectronic.toString());
    formData.append('SignatureName', request.signatureName);
    formData.append('SignatureJobTitle', request.signatureJobTitle);
    formData.append('SignatureDate', request.signatureDate.toISOString().split('T')[0]);
    formData.append('SameAsBusiness', request.sameAsBusiness ? 'true' : 'false');

    if (request.w9DocumentFile) {
      formData.append('W9DocumentFile', request.w9DocumentFile);
    }

    this.ngx.show();
    this.isLoading = true;

    this.voucherService.createVoucherProgram(formData).subscribe({
      next: (res) => {
        this.ngx.hide();
        this.isLoading = false;
        if (res && res.voucherFiles) {
          this.vouchersList = res.voucherFiles.filter((c: { fileType: string; }) => c.fileType === '1' || c.fileType === '2');
          this.agreementFile = res.voucherFiles.find((c: { fileType: string; }) => c.fileType === '3');
        }
        this.isSubmitted = true;
        this.voucherForm.markAsPristine();
        this.unsavedService.markSaved(this.voucherForm);
        this.voucherFiles = res.voucherFiles || [];
        this.activeStep = 5;
      },
      error: (err) => {
        this.ngx.hide();
        this.isLoading = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.SaveFailedMessage;
        this.modalDlg = true;
      }
    });
  }

  toBoolean(value: string | boolean | null): boolean {
    return value === true || value === 'true';
  }

  onCheckboxChange(event: any, item: any) {

    const control = this.step1Group.get('vaccines');

    const vaccines = [...(control?.value || [])];

    if (event.target.checked) {

      if (item.vaccineTypeName != 'Flu (Influenza)' && item.vaccineTypeName != 'Trivalent 65+') {

        const selectedCount = vaccines.filter(
          (c: any) => c.vaccineTypeName != 'Flu (Influenza)' && c.vaccineTypeName != 'Trivalent 65+'
        ).length;

        if (selectedCount >= this.maxRoutineVaccineSelections) {

          event.target.checked = false;

          this.dialogSummary = 'Maximum Selection Reached';

          this.dialogMsg =
            "The Enhanced Vaccine Voucher can accommodate a maximum of 11 vaccines. If you need vouchers for more than 11 immunizations, don't worry! You can easily create an additional voucher as soon as you finish completing this one.";

          this.modalDlg = true;

          return;
        }
      }

      if (!vaccines.some(
        (v: any) => v.vaccineId === item.vaccineId
      )) {
        vaccines.push(item);
      }

    } else {

      const index = vaccines.findIndex(
        (v: any) => v.vaccineId === item.vaccineId
      );

      if (index !== -1) {
        vaccines.splice(index, 1);
      }
    }

    control?.setValue(vaccines);
    control?.markAsTouched();
    control?.markAsDirty();
  }

  isSelected(item: any): boolean {
    const vaccines = this.step1Group.get('vaccines')?.value || [];
    return vaccines.some((v: any) => v.vaccineId === item.vaccineId);
  }

  loadDefaultData(): void {

    this.ngx.show()
    forkJoin({
      states: this.companyService.getAllStates(),
      vaccines: this.vaccineService.getAllVaccines(),
      w9: this.companyService.getW9(this.companyId),
      company: this.companyService.getCompanyById(this.companyId)
    })
      .pipe(
        finalize(() => this.ngx.hide())
      )
      .subscribe({
        next: (res) => {
          this.stateList = res.states;
          this.vaccineList = res.vaccines;
          this.filteredVaccineList = res.vaccines;
          this.company = res.company;
          this.step2Group.get('programName')?.setValue(this.company.companyName);
          this.step2Group.get('fluVoucherExpireDate')?.setValue(this.default_flu_exp_date);
          this.step2Group.get('routineVoucherExpireDate')?.setValue(this.default_routine_exp_date);

          if (res.w9) {
            const status = Number(res.w9.verificationStatus);
            this.isW9Uploaded = true;
            if (status === VerificationStatusEnum.Rejected) {
              this.isW9Uploaded = false;
            }
            if (status === VerificationStatusEnum.Approved) {
              this.w9Approved = true;
              this.step5Title = 'Voucher Download';
            } else {
              this.w9Approved = false;
              this.step5Title = 'Business Verification';
            }
          }

          //    this.groupList(this.vaccineList);
          this.categoryList = Array.from(
            new Map(
              res.vaccines.map(item => [
                item.categoryCode,
                { categoryCode: item.categoryCode, categoryName: item.categoryName }
              ])
            ).values()
          );

          this.voucherForm.markAsPristine();
          this.unsavedService.registerForm(this.voucherForm);
        },
        error: (err) => {
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.ErrorInAPICall;
          this.modalDlg = true;
        }
      });
  }


  okClicked() {
    this.modalDlg = false;
  }

  doneClicked() {
    this.router.navigate(['/home']);
  }

  onStepClick(targetStep: number) {
    if (!this.w9Approved && !this.isW9Uploaded && targetStep !== 1) {
      this.dialogSummary = 'Complete Business Verification';
      this.dialogMsg = 'To continue with voucher setup, you’ll need to upload your business or organization’s IRS Form W-9 and provide your EIN for business verification.';
      this.dialogType = 'business-verification';
      this.modalDlg = true;
      this.activeStep = 1;
      return;
    }
    else if (!this.w9Approved && this.isW9Uploaded && targetStep !== 1) {
      this.dialogSummary = 'Business Verification Pending';
      this.dialogMsg = 'You\'re business verification is under way! As soon as your account is approved, we\'ll send you a follow-up email and you can start your Employee Voucher Program.';
      this.dialogType = 'normal';
      this.modalDlg = true;
      this.activeStep = 1;
      return;
    }

    if (this.isSubmitted && targetStep !== 5) {
      return;
    }

    if (!this.canNavigateToStep(targetStep)) {
      const group = this.getStepGroup(this.activeStep);
      group.markAllAsTouched();
      this.showValidationDialog();
      return;
    }

    if (targetStep === 2) {
      this.updateVaccineFlags();
    }

    if (targetStep === this.maxCompletedStep + 1) {
      const currentGroup = this.getStepGroup(this.maxCompletedStep);

      if (currentGroup.invalid) {
        currentGroup.markAllAsTouched();
        this.showValidationDialog();
        return;
      }

      this.maxCompletedStep = targetStep;
    }

    this.activeStep = targetStep;
  }

  getStepGroup(step: number): FormGroup {
    const finalStep = this.isW9Uploaded ? 5 : 6;

    switch (step) {
      case 1: return this.step1Group;
      case 2: return this.step2Group;
      case 3: return this.step3Group;
      case 4: return this.step4Group;
      case 5: return this.step5Group;
      default: return this.step1Group;
    }
  }

  showValidationDialog() {
    this.dialogSummary = 'Validation Required';
    this.dialogMsg = 'Please complete required fields before continuing.';
    this.dialogType = 'normal';
    this.modalDlg = true;
  }

  getStepClass(step: number): string {

    const group = this.getStepGroup(step);

    if (step === this.activeStep) return 'active-step';

    if (step < this.activeStep && group.valid) {
      return 'completed-step';
    }
    return 'pending-step';
  }

  canNavigateToStep(targetStep: number): boolean {
    const finalStep = this.isW9Uploaded ? 5 : 6;

    // After submission, allow navigation only to the final step
    if (this.isSubmitted) {
      return targetStep === finalStep;
    }

    // Prevent manual navigation to the final step before submission
    if (targetStep === finalStep) {
      return false;
    }

    // Allow access to the current step
    if (targetStep === this.activeStep) {
      return true;
    }

    // Allow navigation to completed steps
    if (targetStep <= this.maxCompletedStep) {
      return this.arePreviousStepsValid(targetStep);
    }

    // Validate all previous steps before allowing forward navigation
    for (let i = 1; i < targetStep; i++) {
      const group = this.getStepGroup(i);
      if (group.invalid) {
        return false;
      }
    }

    // Allow moving to the next sequential step
    return targetStep === this.maxCompletedStep + 1;
  }
  arePreviousStepsValid(targetStep: number): boolean {

    for (let i = 1; i < targetStep; i++) {
      const group = this.getStepGroup(i);

      if (group.invalid) {
        return false;
      }
    }

    return true;
  }

  isStepLockedAfterSubmit(step: number): boolean {
    return this.isSubmitted && step !== 6;
  }

  updateVaccineFlags() {
    const vaccines = this.step1Group.get('vaccines')?.value || [];

    this.isFluVaccine = false;
    this.isRoutineVaccine = false;

    vaccines.forEach((vaccine: VaccineResponse) => {
      if (vaccine.vaccineTypeName === 'Flu (Influenza)' || vaccine.vaccineTypeName === 'Trivalent 65+') {
        this.isFluVaccine = true;
      } else {
        this.isRoutineVaccine = true;
      }
    });
  }

  canDeactivate(): Promise<boolean> | boolean {

    // Skip guard during session timeout logout
    if (sessionStorage.getItem('isLoggingOut') === 'true') {
      return true;
    }

    // Skip warning when intentionally navigating
    // to Business Verification
    if (this.skipUnsavedChangesGuard) {
      return true;
    }

    // No unsaved changes
    if (!this.unsavedService.hasChanges(this.voucherForm)) {
      return true;
    }

    // Allow navigation after successful submission
    if (this.isSubmitted) {
      return true;
    }

    const hasChanges =
      this.voucherForm?.dirty ||
      this.step1Group.value.vaccines?.length > 0;

    if (!hasChanges) {
      return true;
    }

    this.dialogSummary = 'Warning!';
    this.dialogMsg =
      'This action will take you out of the voucher setup and your progress will not be saved. Are you sure you want to leave?';

    this.dialogType = 'unsaved';
    this.modalDlg = true;

    return new Promise<boolean>((resolve) => {
      this.resolveGuard = resolve;
    });
  }

  downloadFile(fileName: string, fileType: string = "3") {

    let containerType = "3";
    // switch(fileType)
    // {
    //   case "Agreement":
    //     containerType = "1";
    //     break;
    //   case "Flu":
    //     containerType = "2";
    //     break;
    //   default:
    //     containerType = "3";
    //     break;
    // }

    const payload = {
      fileName: fileName,
      containerType: containerType
    }

    this.ngx.show();
    this.isLoading = true;

    this.companyService.downloadFile(payload)
      .subscribe(
        {
          next: (blob) => {
            this.ngx.hide();
            this.isLoading = false;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          },

          error: (err) => {
            this.ngx.hide();
            this.isLoading = false;
            this.dialogSummary = Messages.ErrorTitle;
            this.dialogMsg = "Download Failed";
            this.modalDlg = true;
          }
        });
  }

  navigateToBusinessVerification() {
    this.skipUnsavedChangesGuard = true;
    this.router.navigate(['/w9-business-verification']);
  }

}
